import { memo } from 'react';

import { MegaphoneIcon } from '@air/design-icons';

import { NullState } from '~/components/NullState';

export const ANNOUNCEMENTS_NEWS_EMPTY_TEST_ID = 'ANNOUNCEMENTS_NEWS_EMPTY';

export const AnnouncementsNewsEmpty = memo(() => (
  <NullState
    className="pt-16 md:pt-16"
    headingAs="h2"
    icon={MegaphoneIcon}
    testId={ANNOUNCEMENTS_NEWS_EMPTY_TEST_ID}
    title="No news yet"
    description="Product updates and announcements from Air will appear here."
  />
));

AnnouncementsNewsEmpty.displayName = 'AnnouncementsNewsEmpty';
